<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('orders')">{{__('Orders')}}</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> {{__('Create')}}
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-9xl">
        
        <!-- <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
            <span v-for="label in labels" :key="label.id" style="padding:5px;" v-bind:class = "label_id == label.id ?'selected':''"> 
                <span v-on:click="selectLabel(label.id, label.price_per_1k, label.label_name, label.thumbnail_path)" v-bind:class = "label_id == label.id ?'selectedImg':'labelFile'"> 
                    <img v-if="label.thumbnail_path.length > 4" :src="'/storageThumbnail/'+label.thumbnail_path" style="max-width: 200px; max-height:150px;" />
                </span>
                <span style="margin-top:10px;text-align: center; display:flex; align-items: center; justify-content: center;"> 
                    {{label.label_name | subStr}} 
                    <a :href="'/storageFile/'+label.file_path" target="_blank" >
                      <icon name="eye-plus" class="block w-6 h-6 fill-indigo-400" v-bind:class = "form.label_id == label.id ?'selectedIcon':''" />
                    </a>
                </span>
            </span>
            <span>
              <span class="labelFile" style="padding:5px;margin-top:15px;" v-on:click="addExtraRibbons()">
                <img :src="'/storageThumbnail/extraribbons.png'" style="width: 200px;" />
              </span>
              <span style="margin-top:5px;text-align: center;display:flex; align-items: center; justify-content: center;"> 
                Add Extra 10 Ribbons
              </span>
            </span>
        </div> -->

        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <div class="cards" style="float:left;" v-for="labelT in labels" :key="labelT.id" 
            :style="{ backgroundImage:`url(/storageThumbnail/${labelT.thumbnail_path})`, backgroundSize: `65% auto`, backgroundPositionY: `5px`}"
             v-on:click="selectLabel(labelT.id, labelT.price_per_1k, labelT.label_name, labelT.thumbnail_path, labelT.ribbon)" 
             v-bind:class = "label_id == labelT.id ?'selectedNew':'labelFile'"
             v-if="labelT.price_per_1k > 0">
              <p>
                <ul>
                  <li class="p-1">{{ labelT.label_name | subStr }} ({{ labelT.price_per_1k }} €)</li>
                  <!-- <li class="p-1">{{ labelT.organization.name }}</li> -->
                </ul>
              </p>
              <div class="bottom-bar">
                  <a :href="'/storageFile/'+labelT.file_path" target="_blank" title="View Label File" >
                    <icon name="view" class="block w-6 h-6 fill-indigo-400" />
                  </a>
                  <!-- <inertia-link v-if="$page.props.auth.user.owner" class="pl-4 flex items-center focus:text-white-500" style="float:left;" :href="route('labels.edit', labelT.id)">
                    <icon name="edit" class="block w-6 h-5 fill-indigo-400" />
                  </inertia-link>
                  <button v-if="!labelT.deleted_at && $page.props.auth.user.owner" class="pl-2 text-red-600 hover:underline" style="float:left;" tabindex="-1" type="button" @click="destroy(labelT.id)">
                    <icon name="cross" class="block w-6 h-6 fill-red-400" />
                  </button> -->
              </div>
            </div>
            <!-- <div>
               <span class="labelFile" style="padding:5px;margin-top:15px;" v-on:click="addExtraRibbons()"
               v-bind:class = "extraRibbons > 0 ?'selectedNew':'labelFile'">
                <img :src="'/storageThumbnail/extraribbons.png'" style="width: 200px;" />
              </span>
              <span style="margin-top:5px;text-align: center;display:flex; align-items: center; justify-content: center;"> 
                Add Extra 10 Ribbons
              </span>
            </div> -->
        </div>

      <form @submit.prevent="store">

        <div class="max-w-7xl dbr">
          <div class="p-8 -mr-6 -mb-8 flex-wrap lg:w-1/3" v-if="this.ribbon">
            <select-input v-model="quantity" :error="form.errors.quantity" class="pr-6 pb-8 w-full" :label="__('Quantity')">
              <option :value="1"> 10 ({{__('Ribbons')}})</option>
              <option :value="2"> 20 ({{__('Ribbons')}})</option>
              <option :value="3"> 30 ({{__('Ribbons')}})</option>
              <option :value="4"> 40 ({{__('Ribbons')}})</option>
              <option :value="5"> 50 ({{__('Ribbons')}})</option>
            </select-input>
          </div>

          <div class="p-8 -mr-6 -mb-8 flex-wrap lg:w-1/3" v-else >
            <select-input v-model="quantity" :error="form.errors.quantity" class="pr-6 pb-8 w-full" :label="__('Quantity')">
              <option :value="1"> 1 {{__('Roll')}} (2500 {{__('Labels')}})</option>
              <option :value="2"> 2 {{__('Rolls')}} (5000 {{__('Labels')}})</option>
              <option :value="3"> 3 {{__('Rolls')}} (7500 {{__('Labels')}})</option>
              <option :value="4"> 4 {{__('Rolls')}} (10,000 {{__('Labels')}})</option>
              <option :value="5"> 5 {{__('Rolls')}} (12,500 {{__('Labels')}})</option>
            </select-input>
          </div>
          
          <div class="p-8 -mr-6 -mb-8 flex-wrap lg:w-1/3" >
            <button v-on:click="updateOrderDetails()" type="button" class="btn-indigo" >{{__('Add')}} </button>
          </div>
        </div>
        
         <div class="p-8 -mr-6 -mb-8 flex flex-wrap max-w-6xl" style="margin-bottom:4rem;display:block;">
           <div class="bg-white rounded-md shadow overflow-x-auto">
              <table class="w-full whitespace-nowrap">
                  <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <th class="border-t border-r px-6 pt-6 pb-4 font-bold text-left">  {{__('Invoice')}} {{__('Address')}} </th>
                    <td class="border-t px-6 pt-6 pb-4 text-left" colspan="2"> {{contact_details.address}}, {{contact_details.city}}, 
                      {{contact_details.region}}, {{contact_details.country}}, {{contact_details.postal_code}}
                    </td>
                  </tr>
                   <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                      <th class="border-t border-r px-6 pt-6 pb-4 font-bold text-left">{{__('Order Items')}}</th>
                      <td class="border-t px-2 pt-1 pb-1 text-left">
                        <div  v-if="this.form.orderDetails.length > 0" >
                          <span class="p-2 flex flex-wrap max-w-6xl" style="padding:30px; height:80px;" v-for="order, indx in this.form.orderDetails" :key="indx"> 
                              <span v-if="order[5]">
                                {{getBoxes(1)}} ({{order[1]*10}} {{__('Ribbons')}})
                              </span>
                              <span v-else>
                                {{getBoxes(order[1])}} {{order[3]}} ({{order[1]*2500}} {{__('Labels')}})
                              </span>
                          </span>
                        </div>
                         <!-- <div  v-if="this.extraRibbons > 0" >
                          <span class="p-2 flex flex-wrap max-w-6xl" style="padding:30px; height:80px;" > 
                              1 Box ({{this.ribbonDetails[1]*10}} {{__('Ribbons')}})
                          </span>
                        </div> -->
                      </td>
                      <td class="border-t px-2 pt-1 pb-1 text-left">
                        <div  v-if="this.form.orderDetails.length > 0" >
                          <span class="py-2 flex flex-wrap max-w-6xl" v-for="order, indx in this.form.orderDetails" :key="indx"> 
                            <img v-if="order[4].length > 4" :src="'/storageThumbnail/'+order[4]" style="width: 100px;" />
                          </span>
                        </div>
                        <!-- <div  v-if="this.extraRibbons > 0" >
                          <span class="py-2 flex flex-wrap max-w-6xl" > 
                            <img v-if="ribbonDetails[4].length > 4" :src="'/storageThumbnail/'+ribbonDetails[4]" style="width: 100px;" />
                          </span>
                        </div> -->
                      </td>
                    </tr>
                   <!-- <tr class="hover:bg-gray-100 focus-within:bg-gray-100" v-if="this.extraRibbons > 0">
                    <th class="border-t border-r px-6 pt-6 pb-4 font-bold text-left">{{__('Extra')}} {{__('Ribbons')}}</th>
                    <td class="border-t px-6 pt-6 pb-4 text-left" > {{this.extraRibbons}} {{__('Ribbons')}}</td>
                    <td class="border-t px-6 pt-6 pb-4 text-left" > 
                      <div class="number" style="float:right;">
                        <span class="minus" v-on:click="remove10ExtraRibbons()">-</span>
                          <text-input v-model="this.extraRibbons" name="ribbons" class="ribbons-input" readonly />
                        <span class="plus" v-on:click="addExtraRibbons()">+</span>
                      </div>
                    </td>
                  </tr> -->
                  <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <th class="border-t border-r px-6 pt-6 pb-4 font-bold text-left">  {{__('Shipping')}} {{__('Address')}} </th>
                    <td class="border-t px-6 pt-6 pb-4 text-left" colspan="2" v-if="shippingAddress">
                      {{shipping_address.address}}, {{shipping_address.city}}, 
                      {{shipping_address.region}}, {{shipping_address.country}}, {{shipping_address.postal_code}}   
                    </td>
                    <td class="border-t px-6 pt-6 pb-4 text-left" colspan="2" v-else> 
                      
                    </td>
                  </tr>
                  <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                      <th class="border-t border-r px-6 pt-6 pb-4 font-bold text-left">{{__('Shipping')}} {{__('Fee')}}</th>
                      <td class="border-t px-6 pt-6 pb-4 text-left" colspan="2"> {{this.shippingFee}} € </td>
                    </tr>
                  <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                      <th class="border-t border-r px-6 pt-6 pb-4 font-bold text-left">{{__('Order')}} {{__('Total Cost')}}</th>
                      <td class="border-t px-6 pt-6 pb-4 text-left" colspan="2"> {{this.form.orderCost}} € </td>
                    </tr>
              </table>
           </div>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{__('Create')}} {{__('Order')}}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Pdf from 'vue-pdf'

export default {
  metaInfo: { title: 'Create Order' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    Pdf,
    Icon,
  },
  created(){
    // console.log(this.shipping_address)
  },
  layout: Layout,
  props: {
    labels: Array,
    contact_details: Object,
    shipping_address: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        orderDetails : [],
        orderCost: 0,
        orderQuantity : 0,
        ribbonDetails: [],
      }),
      quantity: null,
      label_id: null,
      labelPricePer1k: null,
      label_name: null,
      thumbnail_path: null,
      ribbon: false,
      extraRibbons: 0,
      shippingFee: 15,
      ribbonDetails: [],
      shippingAddress: (this.contact_details.shipping_address_id?true:false)
    }
  },
mounted(){
  // console.log(this.labels)
//   console.log(this.contact_details)
},
filters: {
  	subStr: function(string) {
    	return string.substring(0,15) + '...';
        }
},
  methods: {
    store() {
      
        // if(this.ribbonDetails.length > 0 && this.ribbonDetails[1] > 0){
        //    this.form.ribbonDetails.push([this.ribbonDetails[0], this.ribbonDetails[1], this.ribbonDetails[2], this.ribbonDetails[3], this.ribbonDetails[4]])
        //    this.form.orderQuantity = (parseInt(this.form.orderQuantity)+ 1)
        // }
        // console.log(this.form)

        // if(this.form.orderDetails.length < 1 && this.form.ribbonDetail < 1) {
        if(this.form.orderDetails.length < 1) {
          alert('Please Add a label and Quantity')
        } else {
            this.form.post(this.route('orders.store'))
        }
    },
    updateOrderDetails(){
      if(this.label_id == null) {
            alert('Please select a label')
        } else if(this.quantity == null) {
            alert('Please select quantity.')
        } else {
          this.form.orderDetails.push([this.label_id, this.quantity, this.labelPricePer1k, this.label_name, this.thumbnail_path, this.ribbon])
          this.updateOrderCost().then(() => {
            this.label_id = null
            this.quantity = null
            this.labelPricePer1k = null
            this.label_name = null
            this.thumbnail_path = null
            this.ribbon = false
            // console.log(this.form)
          })  
        }
    },
    selectLabel(labelId, price_per_1k, label_name, thumbnail_path, ribbon){
        this.label_id = labelId
        this.labelPricePer1k = price_per_1k
        this.label_name = label_name
        this.thumbnail_path = thumbnail_path
        this.ribbon = ribbon
    },
    updateOrderCost(){
      return new Promise((resolve, reject) => {
        if(this.quantity != null && this.label_id == null){
          alert('Please select a label')
        }else{
          if(this.ribbon){
            if(this.form.orderCost < 1){
              this.form.orderCost = (this.quantity * this.labelPricePer1k).toFixed(2)
              this.form.orderQuantity = 1
            }else{
              this.form.orderCost = (parseFloat(this.form.orderCost)+parseFloat((this.quantity * this.labelPricePer1k).toFixed(2))).toFixed(2)
              this.form.orderQuantity = (parseInt(this.form.orderQuantity)+parseInt('1'))
            }
          }else{
            if(this.form.orderCost < 1){
              this.form.orderCost = ((this.quantity * 25 * this.labelPricePer1k)+parseInt(this.shippingFee)).toFixed(2)
              this.form.orderQuantity = this.quantity
            }else{
              this.form.orderCost = ((parseFloat(this.form.orderCost)+parseFloat((this.quantity * 25 * this.labelPricePer1k)+parseInt(this.shippingFee)).toFixed(2))).toFixed(2)
              this.form.orderQuantity = (parseInt(this.form.orderQuantity)+parseInt(this.quantity))
            }
          }
        }
        resolve()
      })
    },
    getBoxes(quantity){
       if(quantity == 1){
        return '1 Roll'
      }else{
        return quantity+' Rolls'
      }
    },
    addExtraRibbons(){
      this.extraRibbons = this.extraRibbons + 10

      // alert(this.form.orderDetails.findIndex(arr => arr.includes(0)))

     if(this.ribbonDetails.length > 0 && this.ribbonDetails[1] > 0){
       this.ribbonDetails[1] = (parseInt(this.ribbonDetails[1]) + 1)
       this.ribbonDetails[2] = (parseInt(this.ribbonDetails[2]) + 80)
     }else{
      this.ribbonDetails = [0, 1, 80, 'Ribbons', 'extraribbons.png']
     }

     this.form.orderCost = (parseFloat(this.form.orderCost + 80)).toFixed(4)

    //  console.log(this.ribbonDetails);

      if(this.form.orderCost < 1){
        this.form.orderCost = (this.form.orderCost + 80).toFixed(4)
      }else{
        this.form.orderCost = (parseFloat(this.form.orderCost) + 80).toFixed(4)
      }
    },
    remove10ExtraRibbons(){
      this.extraRibbons = this.extraRibbons - 10

      if(this.ribbonDetails.length > 0 && this.ribbonDetails[1] > 0){
        this.ribbonDetails[1] = (parseInt(this.ribbonDetails[1]) - 1)
        this.ribbonDetails[2] = (parseInt(this.ribbonDetails[2]) - 80)
      }else{
        this.ribbonDetails = []
      }

      // console.log(this.ribbonDetails);

      if(this.form.orderCost < 1){
        this.form.orderCost = (this.form.orderCost - 80).toFixed(4)
      }else{
        this.form.orderCost = (parseFloat(this.form.orderCost) - parseFloat(80).toFixed(4)).toFixed(4)
      }
    },
    removeExtraRibbons(){
      this.extraRibbons = 0
    }
  }
}
</script>
<style scoped>
.labelFile{
  /* filter: gray; 
      -webkit-filter: grayscale(1); 
      -webkit-transition: all .8s ease-in-out; */
    min-height: 160px;
    display: inline-block;
}

.cards{
  width:215px;
  height:240px;
  background:#fff;
  margin:20px;
  border-radius:0.375rem;
  /* box-shadow:0px 0px 15px 0px #313131; */
  border: 1.5px solid #e2e8f0;
  background-size:102%;
  background-repeat:no-repeat;
  background-position:top center;
  position:relative;
  overflow:hidden;
}
.bottom-bar{
  width:100%;
  height:45px;
  position:absolute;
  bottom:-100%;
  background:#fff;
  transition:all 0.3s;
  text-align:center;
  display:flex;
  justify-content:center;
  align-items:center;
  z-index:99;
  border-top:1px solid #3333;
}
.cards:hover .bottom-bar{
  bottom:0px;
}
.cards a{
  cursor:pointer;
  padding:5px 10px;
  border-radius:4px;
  color:whitesmoke;
}
.cards a:hover{
  background:#3333;
  color:white;
}
.cards p{
  text-align:center;
  position:absolute;
  width:100%;
  bottom:5px;
  /* font-size:18px; */
  color:#39415a;
}

.selected{
    border: #2f365f 2px solid;
    border-radius: 8px;
    background-color: #535c8a;
    color: #ffffff;
    min-height: 160px;
    display: inline-block;
}
.selectedNew{
    border: #2f365f 3px solid;
    border-radius: 8px;
    /* background-color: #535c8a; */
    color: #ffffff;
    min-height: 160px;
    display: inline-block;
}
.selectedIcon{
  fill: #ffffff;
}
.labelFile:hover {
  filter: none;
      -webkit-filter: grayscale(0);
      -webkit-transform: scale(1.01);
      cursor: pointer;
}
.selectedImg{
  filter: none;
      -webkit-filter: grayscale(0);
      -webkit-transform: scale(1.01);
}

/* span {cursor:pointer; } */
		.minus, .plus{
      cursor:pointer;
			width:32px;
			height:44px;
			background:#f2f2f2;
			border-radius:4px;
			padding:11px 5px 8px 5px;
			border:1px solid #ddd;
      display: inline-block;
      vertical-align: middle;
      text-align: center;
		}
		.ribbons-input{
			height:44px;
      width: 75px;
      text-align: center;
      font-size: 16px;
			border:1px solid #ddd;
			border-radius:4px;
      display: inline-block;
      vertical-align: middle;
    }

@media screen and (min-width: 580px) {
    .dbr{
      display:block ruby;
    }
 }
</style>
